import { FC } from "react";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

interface BorderBottomIconProps {
  children: string;
}

const BorderBottomIcon: FC<BorderBottomIconProps> = ({ children }) => (
  <>
    <Typography
      variant="h2"
      component="span"
      sx={{
        position: "absolute",
        bottom: "15%",
        left: 0,
        fontSize: { xs: 12, md: 18, lg: 22, xl: 28 },
        fontWeight: 800,
      }}
    >
      {children}
    </Typography>
    <Box
      component="svg"
      width="307"
      height="70"
      viewBox="0 0 307 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        height: "auto",
        width: "100%",
      }}
    >
      <path d="M0 68H239L305 2" stroke="currentColor" strokeWidth="4" />
    </Box>
  </>
);

export default BorderBottomIcon;
